import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t py-10 px-4 bg-gray-900 text-white">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <h3 className="text-xl font-bold mb-1">Daily UAE Jobs</h3>
            <p className="text-gray-400 text-sm mb-3">From CV to Interview, Your Trusted Career Partner.</p>
            <p className="text-sm text-gray-400">
              Support: <a href="mailto:admin@dailyuaejobs.com" className="hover:text-white">admin@dailyuaejobs.com</a><br />
              WhatsApp: <a href="https://wa.me/971521310804" className="hover:text-white" target="_blank" rel="noopener noreferrer">+971 52 131 0804</a>
            </p>
            <p className="text-xs text-gray-500 mt-3">Operated by Nishu4shaku Digital Marketing Agency</p>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-gray-300">Explore</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/cv" className="hover:text-white">Career Tools</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
              <li><Link to="/success-stories" className="hover:text-white" data-testid="footer-success-stories">Success Stories</Link></li>
              <li><Link to="/community" className="hover:text-white" data-testid="footer-community">Community</Link></li>
              <li><Link to="/affiliate" className="hover:text-white" data-testid="footer-affiliate">Affiliate</Link></li>
              <li><Link to="/b2b" className="hover:text-white">For Business</Link></li>
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-gray-300">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white">Terms & Conditions</Link></li>
              <li><Link to="/refund" className="hover:text-white" data-testid="footer-refund">Refund Policy</Link></li>
              <li><Link to="/payment-policy" className="hover:text-white" data-testid="footer-payment">Payment Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-5">
          <p className="text-xs text-gray-400 leading-relaxed max-w-4xl mb-2" data-testid="footer-disclaimer">
            Daily UAE Jobs is a career support platform, not a recruitment agency. Payment processing and support are handled by Nishu4shaku Digital Marketing Agency. We do not guarantee jobs, interviews, or referrals.
          </p>
          <p className="text-center text-gray-500 text-sm">&copy; 2026 Daily UAE Jobs. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
